export default __webpack_public_path__ + "static/media/logo4a.53f2b6e8.png";